import { ParentProperty } from './../base-models/parent-property';
import { ModelData } from './../base-models/model-data';
import { BaseUpdateComponent } from './base-update-component';
import { BaseEntity } from "../base-models/base-entity";
import { OnInit, AfterViewInit, ViewChild, Input } from "@angular/core";
import { ModalContainerService } from "./containers/services/modal-container.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { QueryParameter } from '../base-models/query-parameter';
import { List } from 'immutable';
import { ModalService } from '../base-services/modal.service';
// import { ConfirmationDialogButtons } from '../../public_api';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { switchMap } from 'rxjs/operators';
export class BaseModalUpdateComponent<T extends BaseEntity>
    implements OnInit, AfterViewInit{
        constructor(
            protected modalContainerService: ModalContainerService<T>,
            protected activeModal: NgbActiveModal,
            protected modalService: ModalService
        ){
            
        }

        @ViewChild('defaultUpdateButtons', { static: true }) defaultUpdateButtons: any;
        @ViewChild('baseUpdate', /* TODO: add static flag */ {static: true}) baseUpdateComponent: BaseUpdateComponent<T>

        @Input() set modelData(modelData: ModelData){
            if(modelData){
                this.baseUpdateComponent.ModelData = modelData;
                this._modelData = modelData;
            }
        };
        @Input() set ID(value: number){
            if(value)
                this.baseUpdateComponent.ID = value;
                //this._id = value;
        }

        @Input() set parentProperty(value: ParentProperty){
            this.baseUpdateComponent.parentProperty = value;
        }

        @Input() emitItem: boolean = true;
        @Input() set Parameters(value: List<List<QueryParameter>>){
            this.baseUpdateComponent.Parameters = value;
            this._parameters = value;
        }

        _modelData: ModelData;
        _parameters: List<List<QueryParameter>>;
        saveDisabled: boolean = false;

        //private _id: number;

        private _close: boolean;

        ngOnInit(){

        }

        ngAfterViewInit(){
          this.baseUpdateComponent.ItemSaved.subscribe((item: T) => {
            this.OnItemSaved(item);
          });

          if (this.defaultUpdateButtons) {
            this.defaultUpdateButtons.SaveItemClicked.subscribe(() => {
              this.Save();
            });

            this.defaultUpdateButtons.SaveCloseItemClicked.subscribe(() => {
              this.Save(true);
            });

            this.defaultUpdateButtons.CloseItemClicked.subscribe(() => {
              this.Close();
            });

            this.defaultUpdateButtons.AddItemClicked.subscribe(() => {
              if (this.baseUpdateComponent.AddItem) this.baseUpdateComponent.AddItem();
            });

            this.defaultUpdateButtons.DeleteItemClicked.subscribe(() => {
              if (this.baseUpdateComponent.Delete) this.baseUpdateComponent.Delete();
            });

            this.defaultUpdateButtons.PrintItemClicked.subscribe(() => {
              if (this.baseUpdateComponent.Print) this.baseUpdateComponent.Print();
            });

            this.defaultUpdateButtons.LockUnLockClicked
              .pipe(switchMap(() => this.baseUpdateComponent.LockUnLock()))
              .subscribe((item) => {
                if (item.ID != -1)
                  this.defaultUpdateButtons.LockedButton = item.Useridlk > 0;
              });

            this.defaultUpdateButtons.ResetItemClicked.subscribe(() => {
              this.baseUpdateComponent.Reset(true).subscribe(() => {
                this.defaultUpdateButtons.PrintButtonEnable = true;
              });
            });
          }
            this.baseUpdateComponent.ItemLoaded.subscribe((item: any) => {
            if (!item || !this.defaultUpdateButtons) return;

            const locked = (item.Editable === false) || (item.Useridlk > 0);
             this.defaultUpdateButtons.LockedButton = locked;
             });
     }

        OnItemSaved(item: T){
            if(this._modelData.MainList.CloseAfterSave || this._close)
                this.activeModal.close(item);
            if(this.emitItem)
                this.modalContainerService.EmitItem(item);
        }

        Save(close: boolean = false){
            this.saveDisabled = true;
            setTimeout(() => {
                this.saveDisabled = false;
            }, 1000)
            this._close = close;
            this.baseUpdateComponent.SaveItem();
        }

        Close() {
            if (!this.baseUpdateComponent.canDeactivate()) {
                this.modalService.ShowConfirmationDialog(
                    "Obaveštenje",
                    "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
                    "question",
                    ConfirmationDialogButtons.ConfirmCancel
                ).result.then((result) => {
                    if (result) {
                        this.proceedToClose();
                    }
                }).catch(() => {
                });
            } else {
                this.proceedToClose();
            }
        }

  private proceedToClose() {
            if (this.baseUpdateComponent.SavedViewItem) {
                this.activeModal.close(this.baseUpdateComponent.SavedViewItem);
            } else {
                this.activeModal.dismiss();
 //if(this.baseUpdateComponent.IsFormTouched)
                //this.Save();
            //this.modalContainerService.EmitItem({ID: this.baseUpdateComponent.Item.ID} as T);
            //let itemView = {};
            //this.baseUpdateComponent.LoadItemView()
                //.subscribe(data => {
                    //itemView = data;
                    //this.modalContainerService.EmitItem(itemView as T);
                //})
            }
        }
    }
